import { Routes } from "@/apps/normal/router/routes";
import { navService } from "@package/shared/admin/service/nav.service";
import { isEmpty } from "@package/shared/util/data";
import type { Router } from "vue-router";

export function configureRouter(router: Router): void {
  router.beforeEach(async (to) => {
    if (to.path === Routes.home && isEmpty(to.query.nid)) {
      if (!navService.dataSource.length) await navService.requestDataSource();
      const nav = navService.dataSource.find(_ => _.type === 'home');
      if (nav) router.replace({ path: Routes.home, query: { nid: nav.id } });
    }
  });
}
